export default __webpack_public_path__ + "e83bcca49a6618c4afd7f350d14a824e.png";